import { trackAnalyticsEvent } from "../appInterface";
import {
    IS_COMMUNITY_ONBOARDING_SESSION_KEY,
    IS_R2R_USER_SESSION_KEY,
    KEY_USER_ID,
} from "../constants";
import { LocationIds } from "../../modules/about-me/about-me.types";
import { JobTypesId } from "../../modules/preferences/utils";

export const debounce = <T extends (...args: any[]) => ReturnType<T>>(
    callback: T,
    timeout: number
): ((...args: Parameters<T>) => void) => {
    let timer: ReturnType<typeof setTimeout>;

    return (...args: Parameters<T>) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback(...args);
        }, timeout);
    };
};

export const trackMixpanelEvent = (eventName: String, payload: any = {}) => {
    const isCommunityOnboardingEnabled = sessionStorage.getItem(
        IS_COMMUNITY_ONBOARDING_SESSION_KEY
    );
    const source = isCommunityOnboardingEnabled
        ? null
        : isRnRUser()
        ? "R+R Enrichment"
        : "Onboarding";
    try {
        console.table({
            eventName,
            source,
            ...payload,
            eventType: "MIXPANEL_EVENT",
        });
        trackAnalyticsEvent(
            eventName,
            {
                source,
                ...payload,
            },
            ["MIXPANEL"]
        );
    } catch (error) {
        // console.error("Failed to update analystics", { eventName, payload });
    }
};

export const updateUserProfile = (payload: any) => {
    try {
        const userId = sessionStorage.getItem(KEY_USER_ID);
        console.table({ ...payload, eventType: "USER_PROFILE_UPDATE" }, ["key", "value"]);
        (window as any)?.appInterface.setAnalyticsUserProperty(
            JSON.stringify({ ...payload, userId }),
            ["MIXPANEL"]
        );
    } catch (error) {}
};

export const removeHash = (onSuccess: any = null) => {
    var uri = window.location.toString();

    if (uri.indexOf("#") > 0) {
        history.back();
    }
};

export const scrollElement = (element: HTMLDivElement, scrollFromTop: number = 100) => {
    if (element) {
        if (typeof element.scroll === "function") {
            element.scroll({
                top: element.scrollTop + scrollFromTop,
                behavior: "smooth",
            });
        } else {
            element.scrollTop += 100;
        }
    }
};

export const isRnRUser = () => {
    const val = sessionStorage.getItem(IS_R2R_USER_SESSION_KEY);
    return JSON.parse(val || "false");
};

export const doesContainSpecialCharacter = (value: string): boolean =>
    /[\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/g.test(value);

export const getReturnTo = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("returnTo");
};

export const formatSeconds = (seconds: number) => {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds - hours * 3600) / 60);
    let secs = seconds - hours * 3600 - minutes * 60;

    let m = minutes.toString(),
        s = secs.toString();

    if (minutes < 10) {
        m = `0${minutes}`;
    }
    if (secs < 10) {
        s = `0${secs}`;
    }
    return `${m}:${s}`;
};

export const getNotNullKeyValueObject = (data: Object): Object => {
    const filteredObject: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== "") {
            filteredObject[key] = value;
        }
    }
    return filteredObject;
};
export const getNotNullValueKeys = (arryObj: LocationIds | undefined) => {
    const filteredObject: { [x: string]: null | string | undefined } = {};
    for (const key in arryObj) {
        const value = arryObj[key];
        if (value !== null && typeof value !== "boolean") {
            filteredObject[key] = value;
        }
    }
    return filteredObject;
};

export const isEmpty = (value: string | null | undefined) => {
    return value === undefined || value === null || value === "";
};

export const isGIGDepartment = (departmentId: string | null | undefined) => {
    return (
        departmentId === JobTypesId.DELIVERY_DRIVER_LOGISTICS ||
        departmentId === JobTypesId.DOMESTIC_WORKER ||
        departmentId === JobTypesId.SECURITY_SERVICE
    );
};
